var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.75008 6.54159C1.22081 6.54159 0.791748 6.97065 0.791748 7.49992C0.791748 8.02919 1.22081 8.45825 1.75008 8.45825L13.2501 8.45825C13.7794 8.45825 14.2084 8.02919 14.2084 7.49992C14.2084 6.97065 13.7794 6.54159 13.2501 6.54159L1.75008 6.54159Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82227 12.5723C6.44802 12.9465 6.44802 13.5533 6.82227 13.9276C7.19653 14.3018 7.80331 14.3018 8.17756 13.9276L13.9276 8.17756C14.2904 7.81476 14.3031 7.23057 13.9564 6.85235L8.68553 1.10235C8.32788 0.712192 7.72167 0.685835 7.33152 1.04348C6.94136 1.40112 6.915 2.00733 7.27265 2.39749L11.9235 7.4711L6.82227 12.5723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.90357f45d46c548196469d5ede8de884.svg";
export { ForwardRef as ReactComponent };